function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import styles from './info-slider.scss';
import template from './info-slider.html';

export var InfoSliderComponent = {
  template: template,
  styles: styles,
  controller: /*#__PURE__*/function () {InfoSliderComponentController.$inject = ["$http", "gplansConf"];
    function InfoSliderComponentController($http, gplansConf) {
      "ngInject";_classCallCheck(this, InfoSliderComponentController);
      console.log(this);

      this.$http = $http;
      this.gplansConf = gplansConf;
      // this.ModalsService = ModalsService;
      // this.$scope = $scope;

      this.opened = 0;
    }_createClass(InfoSliderComponentController, [{ key: "$onInit", value: function $onInit()

      {var _this = this;
        this.$http.get(this.gplansConf.API_URL + '/api/v1/study/video-classes').then(function (res) {
          _this.opened = res.data.filter(function (item) {return !item.is_locked;});
        }).catch(function (err) {
          console.warn('getVideoClasses error', err);
        });
      }

      // showVideoModal(item) {
      //   this.ModalsService.custom({
      //     $scope: this.$scope,
      //     onShow: () => {},
      //     onClose: () => {},
      //     template:`
      //     <div style="postion:relative;padding:56.25% 0 0 0;">
      //       <iframe
      //         id="videoPlayer"
      //         src="https://iframe.videodelivery.net/${item.video.code}?autoplay=true&controls=true&loop=false"
      //         style="border:none;position:absolute;left:0;top:0;"
      //         allow="autoplay"
      //         width='100%'
      //         height='100%'
      //       />
      //     </div>
      //     `
      //   });
      // }
    }]);return InfoSliderComponentController;}() };